import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ErrorField from './ErrorField';

class FormElementWrapper extends Component {
    render(){
        const { className, meta, hasOnWheel, children } = this.props;
        const containerClassName = cx(
            'input-element',
            { 'input-element__error': meta && meta.touched && !meta.valid },
            className
        );
        const onWheel = hasOnWheel ? this.onWheel : undefined;

        return (
            <div className={containerClassName} onWheel={onWheel}>
                {this.getLabel()}
                {children}
                <ErrorField meta={meta} />
            </div>
        );
    }

    onWheel = event => event.stopPropagation();

    getLabel = () => {
        const { label, required } = this.props;
        if (!label) return null;

        return (
            <div className="input-label">
                {label}
                {required && <span className="required-field">*</span>}
            </div>
        );
    }
}

FormElementWrapper.propTypes = {
    hasOnWheel: PropTypes.bool,
    required: PropTypes.bool,
    meta: PropTypes.object,
    className: PropTypes.string
};
FormElementWrapper.defaultProps = {
    hasOnWheel: false,
    required: false,
    meta: null,
    className: ''
};

export default FormElementWrapper;
